"use strict";
/*
 * Membrane React package
 * {@link https://www.npmjs.com/package/@membranehq/react}
 * v0.29.2
 */
'use client';

import deepEqual from 'fast-deep-equal';
import { useEffect, useRef } from 'react';

const isPrimitive = (value) => ["number", "string", "boolean"].includes(typeof value);
const warnDeps = (dependencies) => {
  if (dependencies.length === 0) {
    console.warn("useDeepEffect should not be used with no dependencies. Use useEffect instead.");
  }
  if (dependencies.every(isPrimitive)) {
    console.warn("useDeepEffect should not be used with primitive values. Use useEffect instead.");
  }
};
const useGetTriggerDeps = (dependencies, comparisonFn) => {
  const ref = useRef();
  const triggerDeps = useRef(0);
  if (!comparisonFn(dependencies, ref.current)) {
    ref.current = dependencies;
    triggerDeps.current = Math.random();
  }
  return [triggerDeps.current];
};
const useDeepEffect = (fn, dependencies = [], comparisonFn = deepEqual) => {
  warnDeps(dependencies);
  return useEffect(fn, useGetTriggerDeps(dependencies, comparisonFn));
};

export { useDeepEffect };
